import { render } from "./SecurityManager.vue?vue&type=template&id=63f6e5bc"
import script from "./SecurityManager.vue?vue&type=script&lang=js"
export * from "./SecurityManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__